export default __webpack_public_path__ + "static/media/Quick Charge (CHAdeMO).674bcb1d.svg";